'use client';

import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../prismicio-types';
import { Container } from '@/components';
import { Title } from '../../components';
import { AboutUsHeroCards } from './AboutUsHeroCards/AboutUsHeroCards';
import { useVisible } from '@/hooks';

import styles from './aboutUsHero.module.scss';

interface AboutUsHeroProps {
  data: Simplify<Content.HeroSliceAboutUsPrimary>;
}

export const AboutUsHero = ({ data }: AboutUsHeroProps) => {
  const [isVisible, id] = useVisible();
  return (
    <Container id={id} styles={styles.container}>
      <article className={styles.title}>
        <Title text={data.title} isVisible={isVisible} />
      </article>
      <AboutUsHeroCards data={data} isVisible={isVisible} />
    </Container>
  );
};
